import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Tooltip, Tag, DatePicker, Button, Popover, Row, Col, Alert, Space, Input, Spin } from 'antd';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _ from 'lodash';
import qs from 'qs';
import { Form } from '@ant-design/compatible';
import TextTruncate from 'react-text-truncate';
import { checkPermission } from '@/utils/permission';
import {
    cleanObject, stripHtml, receiptStatusOptions, isValidDate, renderPaymentMethod,
    paymentMethodOptions, renderReceiptStatus, renderReceiptRefundStatus, receiptRefundStatusOptions,
    PaymentType, renderReceiptPaymentType,
    receiptTypeOptions, renderMoney
} from '@/utils/helpers';
import HtmlParser from 'react-html-parser';
import NumberFormat from 'react-number-format';
import BaseSelect from '@/components/Elements/BaseSelect';
import moment from 'moment';
import { cancelReceipt, exportReceiptsExcel, getCustomerDepositSummary, getListReceipts, getReceipt, previewReceiptCancellation } from '@/redux/actions/receiptActions';
import { DeleteOutlined, DollarOutlined, ExportOutlined, PrinterOutlined, QuestionCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import DynamicTable from '@/components/DynamicTable';
import PrintTable from './PrintTable';
import CustomerInfoColumn from '@/components/customers/CustomerInfoColumn';
import CreatedAtCell from '@/components/CreatedAtCell';
import ReceiptForm from './ReceiptForm';
import ReceiptDetail from './ReceiptDetail';
import { NotificationManager } from 'react-notifications';
import { isMobile } from 'react-device-detect';
import CustomerSelect from '@/components/customers/CustomerSelect';
import CustomerDepositActions from '@/components/customers/CustomerDepositActions';

const { RangePicker } = DatePicker;

const routes = [
    { path: '/', breadcrumbName: 'Trang chủ' },
    { path: '/recipts', breadcrumbName: 'Phiếu thu' },
];

class ReceiptList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedRowKeys: [],

            // UI
            isOpenForm: false,
            isOpenDetail: false,

            // tách data để tránh re-render list khi mở detail/form
            formReceipt: null,
            detailReceipt: null,

            // detail state
            currentId: null,
            loadingDetail: false,

            // print
            printData: null,
            printing: false,
            exporting: false,
            isDepositCustomerOpen: false,
            depositCustomerId: null,
            depositCustomerLabel: null,
            depositData: null,
            depositLoading: false,
            cancelVisible: false,
            cancelReceipt: null,
            cancelImpact: null,
            cancelReason: '',
            cancelOperationKey: null,
            cancelLoading: false,
        };

        this.printTableRef = React.createRef();

        // cache columns 1 lần (không tạo lại trong render)
        this.columns = this.buildColumns();
    }

    // ---------- lifecycle ----------
    componentDidMount() {
        const query = this.getQueryFromLocation(this.props.location.search);
        this.loadData(query);
    }

    componentDidUpdate(prevProps) {
        // chỉ load lại khi querystring thay đổi thật
        if (prevProps.location.search !== this.props.location.search) {
            const query = this.getQueryFromLocation(this.props.location.search);
            this.loadData(query);
        }
    }

    // ---------- helpers ----------
    getQueryFromLocation(search) {
        return qs.parse((search || '').replace(/^\?/, ''));
    }

    pushQueryToLocation(query) {
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    // ---------- data loading ----------
    loadData(query) {
        this.setState({ isLoading: true });
        return this.props.getListReceipts(query).finally(() => {
            this.setState({ isLoading: false });
        });
    }

    // ---------- filters / table ----------
    onChangeFilter(name, value) {
        let query = this.getQueryFromLocation(this.props.location.search);

        query = { ...query, [name]: value };
        query.page = 1;

        if (name === 'created_at') {
            if (value && value.length > 0) {
                query.created_date_from = moment(value[0]).format('YYYY-MM-DD');
                query.created_date_to = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.created_date_from;
                delete query.created_date_to;
            }
        }

        if (name === 'payment_at') {
            if (value && value.length > 0) {
                query.payment_date_from = moment(value[0]).format('YYYY-MM-DD');
                query.payment_date_to = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.payment_date_from;
                delete query.payment_date_to;
            }
        }

        delete query.created_at;
        delete query.payment_at;

        query = cleanObject(query);
        this.pushQueryToLocation(query);
    }

    onChangeTable(pagination, sorter) {
        let query = this.getQueryFromLocation(this.props.location.search);

        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            };
        }

        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC',
                };
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.pushQueryToLocation(query);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    };

    // ---------- form ----------
    toggleOpenForm = (isOpenForm, formReceipt = null) => {
        this.setState({ isOpenForm, formReceipt });
    };

    onEdit(id) {
        this.props.getReceipt(id).then((res) => {
            this.toggleOpenForm(true, res);
        });
    }

    handleCancelForm = () => {
        this.toggleOpenForm(false, null);
    };

    openDepositCustomer = () => {
        this.setState({ isDepositCustomerOpen: true, depositCustomerId: null, depositCustomerLabel: null, depositData: null });
    };

    openDepositReceive = () => {
        const { depositCustomerId } = this.state;
        if (!depositCustomerId) return;
        if (!checkPermission('customer_deposit', 'view')) {
            this.setState({ isDepositCustomerOpen: false, depositData: { services: [] } });
            return;
        }
        this.setState({ depositLoading: true });
        this.props.getCustomerDepositSummary(depositCustomerId).then(depositData => {
            this.setState({ isDepositCustomerOpen: false, depositData: depositData || {} });
        }).finally(() => this.setState({ depositLoading: false }));
    };

    closeDepositReceive = () => {
        this.setState({ depositCustomerId: null, depositCustomerLabel: null, depositData: null });
    };

    reloadAfterDepositReceive = async () => {
        const { depositCustomerId } = this.state;
        let depositReload = Promise.resolve();
        if (depositCustomerId && checkPermission('customer_deposit', 'view')) {
            depositReload = this.props.getCustomerDepositSummary(depositCustomerId).then(depositData => {
                this.setState({ depositData: depositData || {} });
            }).catch(() => null);
        }
        await depositReload;
        await this.loadData(this.getQueryFromLocation(this.props.location.search));
    };

    // ---------- cancel receipt ----------
    openCancellation = (receipt) => {
        this.setState({
            cancelVisible: true,
            cancelReceipt: receipt,
            cancelImpact: null,
            cancelReason: '',
            cancelOperationKey: `RECEIPT-CANCEL-${receipt.id}-${Date.now()}-${Math.random().toString(16).slice(2)}`,
            cancelLoading: true,
        });
        return this.props.previewReceiptCancellation(receipt.id)
            .then(cancelImpact => this.setState({ cancelImpact }))
            .catch(() => this.setState({ cancelVisible: false, cancelReceipt: null }))
            .finally(() => this.setState({ cancelLoading: false }));
    };

    closeCancellation = () => {
        if (this.state.cancelLoading) return;
        this.setState({ cancelVisible: false, cancelReceipt: null, cancelImpact: null, cancelReason: '', cancelOperationKey: null });
    };

    confirmCancellation = () => {
        const { cancelReceipt: receipt, cancelImpact, cancelReason, cancelOperationKey } = this.state;
        if (!receipt || !cancelImpact?.can_cancel || cancelReason.trim().length < 5) return;
        this.setState({ cancelLoading: true });
        return this.props.cancelReceipt(receipt.id, {
            reason: cancelReason.trim(),
            operation_key: cancelOperationKey,
            impact_hash: cancelImpact.impact_hash,
        }).then(() => {
            this.setState({
                cancelLoading: false,
                cancelVisible: false,
                cancelReceipt: null,
                cancelImpact: null,
                cancelReason: '',
                cancelOperationKey: null,
            });
            return this.loadData(this.getQueryFromLocation(this.props.location.search));
        }).finally(() => this.setState({ cancelLoading: false }));
    };

    // ---------- detail ----------
    toggleOpenDetail = (isOpenDetail) => {
        // khi đóng detail thì clear detailReceipt để nhẹ
        if (!isOpenDetail) {
            this.setState({ isOpenDetail: false, detailReceipt: null, currentId: null, loadingDetail: false });
            return;
        }
        this.setState({ isOpenDetail: true });
    };

    onDetail = (id) => {
        // mở drawer trước + show loading
        this.setState({ isOpenDetail: true, currentId: id, loadingDetail: true });

        return this.props
            .getReceipt(id)
            .then((res) => {
                this.setState({ detailReceipt: res, loadingDetail: false });
            })
            .catch(() => {
                this.setState({ loadingDetail: false });
            });
    };

    // reload detail ONLY (tránh gọi loadData cùng lúc)
    reloadDetailOnly = () => {
        const { currentId } = this.state;
        if (!currentId) return;
        return this.onDetail(currentId);
    };

    // ---------- print ----------
    handlePrint = async (id) => {
        this.setState({ printing: true });

        try {
            const res = await this.props.getReceipt(id);

            const customer = {
                customer_name: res?.customer?.full_name || '',
                customer_phone: Array.isArray(res?.customer?.phones)
                    ? res.customer.phones.map((p) => p?.phone).filter(Boolean).join(', ')
                    : '',
                customer_address: res?.customer?.address || '',
                province_name: res?.customer?.province?.name || '',
                wards_name: res?.customer?.ward?.name || '',
                invoice_no: res?.code || '',
                special_discount: res?.special_discount ?? 0,
                amount_paid: res?.amount_paid ?? 0,
                remaining_debt: res?.remaining_debt ?? 0,
                total_amount_paid: res?.total_amount_paid ?? 0,
            };

            this.setState({ printData: { ...res, customer }, printing: false }, () => {
                Promise.resolve(this.printTableRef.current?.calculateTotal?.()).then(() => {
                    const content = document.getElementById('custom-print-content')?.innerHTML || '';
                    const w = window.open('', '', 'width=900,height=800');
                    w.document.open();
                    w.document.write('<html><head><title>Print</title></head><body>');
                    w.document.write(content);
                    w.document.write('</body></html>');
                    w.document.close();
                    w.print();
                });
            });
        } catch (e) {
            this.setState({ printing: false });
        }
    };

    // ---------- columns ----------
    buildColumns() {
        // dùng arrow fn để giữ this stable, columns tạo 1 lần
        return [
            {
                title: 'Mã phiếu',
                dataIndex: 'code',
                key: 'code',
                width: '100px',
                render: (text, record) => {
                    if (!checkPermission('receipt', 'detail')) return <>{text}</>;

                    return (
                        <Tooltip title="Xem chi tiết phiếu" placement="right">
                            <span className="color-primary item-action-btn" onClick={() => this.onDetail(record.id)}>
                                {text}
                            </span>
                        </Tooltip>
                    );
                },
            },
            {
                title: '#',
                align: 'center',
                width: '50px',
                key: 'action',
                render: (text, record) => <Space>
                    <Tooltip title="In phiếu" placement="right">
                        <Button size="small" type="dashed" loading={this.state.printing} onClick={() => this.handlePrint(record.id)} icon={<PrinterOutlined />} />
                    </Tooltip>
                    {/* {checkPermission('receipt', 'remove') && <Tooltip title="Hủy phiếu" placement="right">
                        <Button size="small" danger type="dashed" onClick={() => this.openCancellation(record)} icon={<DeleteOutlined />} />
                    </Tooltip>} */}
                </Space>,
            },
            {
                title: 'Ngày thu',
                dataIndex: 'payment_at',
                key: 'payment_at',
                width: '100px',
                sorter: true,
                render: (text) => (text ? <>{isValidDate(text, false)}</> : <Tag />),
            },
            {
                title: 'Khách hàng',
                key: 'customer_name',
                width: 300,
                render: (_, record) => {
                    const customer = {
                        id: record?.customer_id,
                        code: record?.customer?.code,
                        full_name: record?.customer?.full_name,
                        branch_name: record?.customer?.branch?.name,
                    };

                    return (
                        <CustomerInfoColumn
                            record={customer}
                            nameField="full_name"
                            idField="id"
                            codeField="code"
                            branchField="branch_name"
                            enableLink={true}
                        />
                    );
                },
            },
            {
                title: 'Tổng',
                dataIndex: 'total_amount',
                key: 'total_amount',
                render: (text) => <NumberFormat value={Math.max(0, Number(text) || 0)} displayType="text" thousandSeparator />,
            },
            {
                title: 'Ưu đãi',
                dataIndex: 'special_discount',
                key: 'special_discount',
                render: (text) => <NumberFormat value={text} displayType="text" thousandSeparator />,
            },
            {
                title: 'Doanh số',
                dataIndex: 'adjusted_sales',
                key: 'adjusted_sales',
                render: (text) => <NumberFormat value={text} displayType="text" thousandSeparator />,
            },
            {
                title: 'Số tiền thu',
                dataIndex: 'amount_paid',
                key: 'amount_paid',
                render: (text) => <NumberFormat value={text} displayType="text" thousandSeparator />,
            },
            {
                title: 'Tổng đã thu',
                dataIndex: 'total_amount_paid',
                key: 'total_amount_paid',
                render: (text) => <NumberFormat value={text} displayType="text" thousandSeparator />,
            },
            {
                title: (
                    <span>
                        Công nợ{' '}
                        <Tooltip title="Công nợ ngay sau khi ghi nhận phiếu thu này. Các khoản thu, hoàn tiền hoặc thay đổi dịch vụ sau đó có thể làm số này khác công nợ hiện tại của khách.">
                            <QuestionCircleOutlined style={{ color: '#8c8c8c', cursor: 'help' }} />
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'remaining_debt',
                key: 'remaining_debt',
                render: (text) => <NumberFormat value={Math.max(0, Number(text) || 0)} displayType="text" thousandSeparator />,
            },
            {
                title: 'Nội dung thu',
                dataIndex: 'items',
                key: 'items',
                width: '200px',
                render: (items, record) => {
                    if (!items || !Array.isArray(items) || !items.length) return null;

                    const firstItem = items[0]?.name;
                    const content = items.map((item, index) => (
                        <div key={index} style={{ padding: '5px 0' }}>
                            {index + 1}. {item.name}
                        </div>
                    ));

                    if (checkPermission('receipt', 'detail')) {
                        return (
                            <Popover placement="right" content={content}>
                                <div className="item-action-btn" onClick={() => this.onDetail(record.id)}>
                                    <TextTruncate line={1} truncateText="…" text={stripHtml(firstItem)} />
                                </div>
                            </Popover>
                        );
                    }

                    return <TextTruncate line={1} truncateText="…" text={stripHtml(firstItem)} />;
                },
            },
            {
                title: 'Trạng thái',
                dataIndex: 'status',
                key: 'status',
                width: '120px',
                render: (text, record) => <div>
                    {renderReceiptStatus(text)}
                    {renderReceiptRefundStatus(record?.refund_summary?.status)}
                </div>,
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '200px',
                render: (text) => (
                    <div style={{ wordBreak: 'break-word' }}>
                        <Tooltip title={HtmlParser(text)} placement="topLeft">
                            <TextTruncate line={2} truncateText="…" text={stripHtml(text)} />
                        </Tooltip>
                    </div>
                ),
            },
            {
                title: 'Hình thức thu',
                dataIndex: 'payment_method',
                key: 'payment_method',
                width: '120px',
                render: (text, record) => <>{(record.payment_breakdowns || record.paymentBreakdowns || []).length
                    ? (record.payment_breakdowns || record.paymentBreakdowns).map(row => <div key={row.id || row.payment_method}>
                        {renderPaymentMethod(row.payment_method)} <strong>{renderMoney(row.amount)}</strong>
                    </div>) : renderPaymentMethod(text)}</>,
            },
            {
                title: 'Loại thanh toán',
                dataIndex: 'payment_type',
                key: 'payment_type',
                width: '140px',
                render: (value) => renderReceiptPaymentType(value),
            },
            // {
            //     title: 'Kết quả thu tiền',
            //     dataIndex: 'settlement_result',
            //     key: 'settlement_result',
            //     width: '150px',
            //     render: (value, record) => renderReceiptCollectionResult(
            //         record.collection_purpose,
            //         value
            //     ),
            // },
            {
                title: 'Ngày tạo',
                dataIndex: 'created_at',
                key: 'created_at',
                width: '220px',
                render: (text, record) => <CreatedAtCell createdAt={text} user={record?.created_user} />,
            },
        ];
    }

    handleExport() {
        const { authUser } = this.props;

        const query = this.getQueryFromLocation(this.props.location.search);
        this.setState({ exporting: true });

        this.props.exportReceiptsExcel(query).catch(() => {
            NotificationManager.error(
                "Có lỗi xảy ra trong quá trình gửi yêu cầu xuất file. Vui lòng thử lại sau.",
                "Lỗi",
                9000
            );
        }).finally(() => {
            this.setState({ exporting: false });
        });

        this.setState({ exporting: false });
        // Thông báo ngay lập tức cho người dùng
        NotificationManager.success(
            `Quá trình xuất file đang được thực hiện. 
            File kết quả sẽ được gửi vào email ${authUser.email} trong ít phút.`,
            "Thông báo",
            9000
        );
    }

    render() {
        const { receipt_list, receipt_summary, pagination, users, filterData } = this.props;

        const {
            isLoading,
            selectedRowKeys,
            isOpenForm,
            isOpenDetail,
            formReceipt,
            detailReceipt,
            loadingDetail,
            exporting,
            isDepositCustomerOpen,
            depositCustomerId,
            depositCustomerLabel,
            depositData,
            depositLoading,
            cancelVisible,
            cancelReceipt,
            cancelImpact,
            cancelReason,
            cancelLoading
        } = this.state;

        const hasSelected = selectedRowKeys.length > 0;

        const query = this.getQueryFromLocation(this.props.location.search);
        const branches = filterData?.branches || [];

        return (
            <div>
                <PageTitle routes={routes} title="Phiếu thu" />

                <div>
                    <TableActionBar
                        isShowAddButton={checkPermission('receipt', 'create')}
                        isShowDeleteButton={false}
                        onAdd={() => this.toggleOpenForm(true, null)}
                        disabled={!selectedRowKeys.length}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        placeholderSearch="Mã phiếu, Mã hoặc tên khách hàng"
                        filterColSpan={6}
                        activeFilter={
                            query.created_date_from ||
                            query.created_date_to ||
                            query.payment_date_from ||
                            query.payment_date_to ||
                            query.created_by ||
                            query.payment_method ||
                            query.payment_type ||
                            query.refund_status ||
                            query.status ||
                            query.branch_id ||
                            query.service_staff_id ||
                            query.mode ||
                            query.receipt_type
                        }
                        filters={[
                            <BaseSelect
                                options={branches || []}
                                optionValue="id"
                                optionLabel="name"
                                placeholder="Chọn cơ sở"
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('branch_id', value)}
                                defaultValue={query.branch_id ? parseInt(query.branch_id, 10) : null}
                            />,
                            <BaseSelect
                                options={paymentMethodOptions || []}
                                onChange={(value) => this.onChangeFilter('payment_method', value)}
                                defaultValue={query.payment_method || null}
                                placeholder="Hình thức thu"
                                className="w-100"
                            />,
                            <BaseSelect
                                options={receiptTypeOptions || []}
                                onChange={(value) => this.onChangeFilter('receipt_type', value)}
                                defaultValue={query.receipt_type || null}
                                placeholder="Loại phiếu thu"
                                className="w-100"
                            />,
                            <BaseSelect
                                options={PaymentType || []}
                                onChange={(value) => this.onChangeFilter('payment_type', value)}
                                defaultValue={query.payment_type || null}
                                placeholder="Loại thanh toán"
                                className="w-100"
                            />,
                            <BaseSelect
                                options={receiptRefundStatusOptions || []}
                                onChange={(value) => this.onChangeFilter('refund_status', value)}
                                defaultValue={query.refund_status || null}
                                placeholder="Trạng thái hoàn tiền"
                                className="w-100"
                            />,
                            <BaseSelect
                                options={receiptStatusOptions || []}
                                onChange={(value) => this.onChangeFilter('status', value)}
                                defaultValue={query.status || null}
                                placeholder="Trạng thái"
                                className="w-100"
                            />,
                            <RangePicker
                                format="DD/MM/YYYY"
                                placeholder={['Ngày thu', 'đến ngày']}
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('payment_at', value)}
                                defaultValue={[
                                    query.payment_date_from ? moment(query.payment_date_from, 'YYYY-MM-DD') : null,
                                    query.payment_date_to ? moment(query.payment_date_to, 'YYYY-MM-DD') : null,
                                ]}
                            />,
                            <RangePicker
                                format="DD/MM/YYYY"
                                placeholder={['Ngày tạo', 'đến ngày']}
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('created_at', value)}
                                defaultValue={[
                                    query.created_date_from ? moment(query.created_date_from, 'YYYY-MM-DD') : null,
                                    query.created_date_to ? moment(query.created_date_to, 'YYYY-MM-DD') : null,
                                ]}
                            />,
                            <BaseSelect
                                options={users || []}
                                optionValue="user_id"
                                optionLabel="display_name"
                                showSearch
                                placeholder="Người tạo"
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('created_by', value)}
                                defaultValue={query.created_by ? parseInt(query.created_by, 10) : null}
                            />,
                            <BaseSelect
                                options={users || []}
                                optionValue="user_id"
                                optionLabel="display_name"
                                showSearch
                                placeholder="Nhân sự phụ trách dịch vụ"
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('service_staff_id', value)}
                                defaultValue={query.service_staff_id ? parseInt(query.service_staff_id, 10) : null}
                            />
                        ]}
                    >
                        <Button className="table-button" loading={exporting} type='default' onClick={() => this.handleExport()} icon={<ExportOutlined />}>Xuất Excel</Button>
                        {checkPermission('customer_deposit', 'receive') && <Button className="table-button" type="primary"
                            icon={<DollarOutlined />} onClick={this.openDepositCustomer}>Nhận tiền cọc</Button>}
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>
                            Refresh
                        </Button>
                        {hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi</span> : ''}
                    </TableActionBar>
                </div>

                <Row gutter={16}>
                    <Col xs={24} md={24} className="mb-3">
                        <Alert
                            description={
                                <>
                                    <strong>Chú ý: </strong>Sử dụng chức năng in phiếu thu, đưa khách hàng ký, không được viết tay trước rồi mới nhập lên hệ thống
                                </>
                            }
                            type="warning"
                        />
                    </Col>
                </Row>

                <div className="has-custom-column-table-btn">
                    <DynamicTable
                        rowKey="id"
                        dataSource={receipt_list || []}
                        columns={this.columns}
                        isLoading={isLoading}
                        pagination={pagination}
                        rowSelection={false}
                        moduleKey="receipt_list"
                        className="has-table-summary"
                        onChangeTable={(p, s) => this.onChangeTable(p, s)}
                        title={() => (
                            <div
                                style={{
                                    textAlign: 'left',
                                    fontSize: 14,
                                }}
                            >
                                <span style={{ color: 'rgba(0, 0, 0, 0.65)' }}>
                                    Tổng số tiền thu{' '}
                                    <Tooltip title="Là tổng giá trị của cột Số tiền thu trên toàn bộ dữ liệu theo bộ lọc hiện tại, không chỉ tính các bản ghi đang hiển thị trên trang.">
                                        <QuestionCircleOutlined
                                            style={{
                                                color: '#8c8c8c',
                                                cursor: 'help',
                                                marginRight: 2,
                                            }}
                                        />
                                    </Tooltip>
                                    :{' '}
                                </span>

                                <strong
                                    style={{
                                        fontSize: 18,
                                        color: '#1677ff',
                                    }}
                                >
                                    <NumberFormat
                                        value={receipt_summary?.amount_paid || 0}
                                        displayType="text"
                                        thousandSeparator
                                        suffix="đ"
                                    />
                                </strong>
                            </div>
                        )}
                    />
                </div>

                {/* Print content chỉ render 1 lần */}
                <div style={{ display: 'none' }}>
                    <div id="custom-print-content">
                        <PrintTable
                            ref={this.printTableRef}
                            customer={this.state.printData?.customer}
                            tableData={this.state.printData?.items || []}
                        />
                    </div>
                </div>

                <ReceiptForm
                    visible={isOpenForm}
                    currentReceipt={formReceipt}
                    reloadData={() => this.loadData(this.getQueryFromLocation(this.props.location.search))}
                    onCancel={this.handleCancelForm}
                />

                <ReceiptDetail
                    visible={isOpenDetail}
                    currentReceipt={detailReceipt}
                    reloadData={this.reloadDetailOnly}
                    onCancel={() => this.toggleOpenDetail(false)}
                    loadingDetail={loadingDetail}
                />

                <Modal visible={isDepositCustomerOpen} destroyOnClose maskClosable={false}
                    width={isMobile ? '100%' : '40%'} title="Chọn khách hàng nhận tiền cọc"
                    okText="Tiếp tục" cancelText="Hủy" confirmLoading={depositLoading}
                    okButtonProps={{ disabled: !depositCustomerId }}
                    onOk={this.openDepositReceive}
                    onCancel={() => this.setState({ isDepositCustomerOpen: false, depositCustomerId: null, depositCustomerLabel: null })}>
                    <div style={{ marginBottom: 8 }}>Khách hàng</div>
                    <CustomerSelect
                        labelFormat="name-code"
                        className="w-100"
                        value={depositCustomerId ? { value: depositCustomerId, label: depositCustomerLabel } : null}
                        onChange={(customerId, customerLabel) => this.setState({
                            depositCustomerId: customerId,
                            depositCustomerLabel: customerLabel,
                        })}
                    />
                </Modal>

                {depositCustomerId && depositData && <CustomerDepositActions
                    customerId={depositCustomerId}
                    data={depositData}
                    reload={this.reloadAfterDepositReceive}
                    autoOpenReceive
                    showActions={false}
                    onClose={this.closeDepositReceive}
                />}

                <Modal
                    visible={cancelVisible}
                    destroyOnClose
                    maskClosable={false}
                    width={isMobile ? '100%' : '50%'}
                    title={`Hủy phiếu thu ${cancelReceipt?.code || ''}`}
                    okText="Xác nhận hủy phiếu"
                    cancelText="Đóng"
                    okButtonProps={{
                        danger: true,
                        disabled: !cancelImpact?.can_cancel || cancelReason.trim().length < 5,
                    }}
                    confirmLoading={cancelLoading}
                    onOk={this.confirmCancellation}
                    onCancel={this.closeCancellation}
                >
                    {cancelLoading && !cancelImpact ? <div style={{ textAlign: 'center', padding: 24 }}><Spin /></div> : <>
                        {cancelImpact?.blockers?.length > 0 && <Alert
                            type="error"
                            message="Chưa thể hủy tự động"
                            description={cancelImpact.blockers.map((message, index) => <div key={index}>• {message}</div>)}
                            style={{ marginBottom: 16 }}
                        />}
                        {cancelImpact?.warnings?.length > 0 && <Alert
                            type="warning"
                            message="Tác động sẽ được hoàn tác"
                            description={cancelImpact.warnings.map((message, index) => <div key={index}>• {message}</div>)}
                            style={{ marginBottom: 16 }}
                        />}
                        {cancelImpact && <div style={{ marginBottom: 16 }}>
                            <div>Tiền thu: <strong>{renderMoney(cancelImpact.collected_amount)}</strong></div>
                            <div>Phân bổ dịch vụ hoàn tác: <strong>{renderMoney(cancelImpact.service_allocation_to_reverse)}</strong></div>
                            <div>Thanh toán sản phẩm hoàn tác/phân bổ lại: <strong>{renderMoney(cancelImpact.product_payment_to_reverse)}</strong></div>
                            <div>Số dư hoàn tác: <strong>{renderMoney(cancelImpact.balance_to_reverse)}</strong></div>
                        </div>}
                        <div style={{ marginBottom: 8 }}>Lý do hủy phiếu</div>
                        <Input.TextArea
                            rows={3}
                            maxLength={1000}
                            value={cancelReason}
                            disabled={!cancelImpact?.can_cancel}
                            placeholder="Nhập lý do tạo nhầm hoặc lý do cần hủy phiếu"
                            onChange={event => this.setState({ cancelReason: event.target.value })}
                        />
                    </>}
                </Modal>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        receipt_list: state.receiptReducer.receipt_list,
        receipt_summary: state.receiptReducer.receipt_summary,
        pagination: state.receiptReducer.pagination,
        users: state.config.users,
        filterData: state.filterReducer.list,
        authUser: state.auth.authUser
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getListReceipts: (filter) => dispatch(getListReceipts(filter)),
        getReceipt: (id) => dispatch(getReceipt(id)),
        previewReceiptCancellation: id => dispatch(previewReceiptCancellation(id)),
        cancelReceipt: (id, data) => dispatch(cancelReceipt(id, data)),
        exportReceiptsExcel: (filter) => dispatch(exportReceiptsExcel(filter)),
        getCustomerDepositSummary: (customerId) => dispatch(getCustomerDepositSummary(customerId)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'ReceiptList' })(ReceiptList));
